module.exports = "<textarea></textarea>\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/codemirror/template.html
// module id = idaq
// module chunks = 0